interface StatCardProps {
  value: string;
  suffix: string;
  label: string;
}

export default function StatCard({ value, suffix, label }: StatCardProps) {
  return (
    <div className="text-center">
      <p className="font-heading text-4xl md:text-5xl font-black text-primary-500 tracking-tight">
        {value}
        <span className="text-3xl md:text-4xl">{suffix}</span>
      </p>
      <p className="mt-2 text-sm text-foreground-500">{label}</p>
    </div>
  );
}